<dx-popup
    #vendorMissingBillHistoryPopup
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="40%"
    [showTitle]="true"
    [title]="vendorMissingBillHistoryTitle"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="!loadingVisible"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onHistoryShown()"
    (onHidden)="onHistoryClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box id="vendorMissingBillHistory" width="100%" height="100%" direction="col" class="box-container">
            <dxi-item [ratio]="1">
                <app-view-history
                    *ngIf="visible"
                    [historySource]="vendorMissingBillHistorySource"
                    [columnDef]="vendorMissingBillHistoryColumns"
                ></app-view-history>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onHistoryClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#vendorMissingBillHistory' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
